import { DateInfoVO } from '../data-models/common.interfaces';

export function isValidDate({ year = 0, month = 0, day = 0 }: DateInfoVO) {
  const date = new Date(year, month, day);
  return (
    date.getFullYear() == year &&
    date.getMonth() == month &&
    date.getDate() == day &&
    date <= new Date()
  );
}
